import axiosInstance from "@js-app/services/http/axios-instance";

class _CentrifugoApi {
    getAccessToken() {
        return axiosInstance.get(`/centrifugo/token`)
    }
}

export const CentrifugoApi = new _CentrifugoApi();
